import {Redirect, Route} from "react-router-dom";
import React from "react";

export function PrivateRoute({isAuthenticated,  children, ...rest}) {
    return (
        <Route
            {...rest}
            render={({location}) =>
                isAuthenticated ?
                    ( children )
                    : (<Redirect to={{pathname: "/", state: {from: location}}}/>)
            }
        />
    );
}
